import AdvisersSearchResultsHtml from '../../app-lite/advisers/templates/advisers.search.results.html';

export function InspectionCtrl (
  $state,
  $translate,
  attachments,
  company,
  companyMessages,
  confirm,
  customer,
  groups,
  inspection_products,
  inspection,
  Inspection,
  messages,
  settings,
  templates,
  vehicle,
  workshopAPI
) {
  var vm = this;

  vm.attachments         = attachments || [];
  vm.company             = company;
  vm.companyMessages     = companyMessages;
  vm.customer            = customer;
  vm.groups              = groups;
  vm.inspection_products = inspection_products;
  vm.settings            = settings;
  vm.templates           = templates;
  vm.vehicle             = vehicle;

  if (inspection.id) {
    vm.template_id = inspection.template_id;
    vm.inspection  = new Inspection(inspection, vm.groups, vm.settings, company);
  }
  else {
    vm.inspection = {};
  }

  vm.attachmentOptions = {
    contact: {
      email: vm.customer.email,
      phone: vm.customer.mobile || vm.customer.phone
    },
    description: $translate.instant('JS_SPACE.INSPECTIONS.INSPECTION_ATTACHMENT'),
    entity     : vm.inspection,
    id_key     : 'inspection_id',
    open       : vm.attachments.length,
    table      : 'inspection',
    routes     : {
      create: '/inspection/add_attachment',
      delete: '/inspection/remove_attachment',
      get   : '/inspection/list_attachments'
    }
  };

  vm.selectCustomer = function (customer) {
    $state.go('app.inspection', {
      customer_id: customer.id
    });
  };

  vm.selectVehicle = function (vehicle) {
    $state.go('app.inspection', {
      customer_id: vehicle.customer_id,
      vehicle_id : vehicle.id
    });
  };

  vm.chooseTemplate = function () {
    var inspection = vm.inspection.id ? vm.inspection : {
      customer_email: vm.customer.email,
      customer_id   : vm.customer.id,
      vehicle_id    : vm.vehicle.id
    };

    inspection.template_id = vm.template_id;

    vm.inspection = new Inspection(inspection, vm.groups, vm.settings);
  };

  vm.serviceAdviserSearch = {
    list       : [],
    templateUrl: AdvisersSearchResultsHtml,
    value      : {
      display_name: inspection.service_adviser_display_name || vm.settings.service_adviser_display_name,
      id          : inspection.service_adviser_id || vm.settings.default_service_adviser_id
    },
    query ( value ) {
      return workshopAPI.get('/service_advisers/list', [ value, 0, '*' ]);
    },
    select (adviser) {
      vm.inspection.service_adviser_id = adviser.id;
      vm.inspection.service_adviser_display_name = adviser.display_name;
    },
    format (adviser) {
      return adviser ? adviser.display_name : '';
    }
  };

  vm.save = function () {
    vm.inspection.save()
    .then(response => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.INSPECTIONS'), 'success');

      if (vm.inspection.id) {
        $state.reload();
      }

      else {
        $state.go('app.inspection', {
          customer_id: response.customer_id,
          vehicle_id : response.vehicle_id,
          id         : response.id
        });
      }
    })
    .catch(err => {
      messages.error(err);
    });
  };

  vm.delete = function () {
    confirm.generic($translate.instant('JS_SPACE.CONFIRM.DELETE_INSPECTION'))
    .then(() => workshopAPI.delete('/inspection', vm.inspection.id))
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.DELETED.INSPECTIONS'), 'success');

      $state.go('app.transaction-center.inspections', {}, { inherit: false });
    })
    .catch(err => {
      messages.error(err);
    });
  };

  vm.void = function () {
    confirm.generic($translate.instant('JS_SPACE.CONFIRM.VOID_INSPECTION'))
    .then(() => vm.inspection.void())
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.VOIDED.INSPECTION'), 'success');

      $state.go('app.transaction-center.inspections', {}, { inherit: false });
    })
    .catch(err => {
      messages.error(err);
    });
  };

  vm.finalize = function () {
    vm.inspection.finalize()
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.INSPECTION_FINALISED'), 'success');

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  vm.convertToEvent = function () {
    vm.inspection.convertToEvent()
    .then(response => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.INSPECTION_CONVERTED'), 'success');

      $state.go('app.event', {
        customer_id: response.customer_id,
        vehicle_id : response.vehicle_id,
        id         : response.event_id
      });
    })
    .catch(err => {
      messages.error(err);
    });
  };

  vm.convertToInvoice = function () {
    vm.inspection.convertToInvoice()
    .then(response => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.INSPECTION_CONVERTED'), 'success');

      $state.go('app.invoice', {
        customer_id: response.customer_id,
        vehicle_id : response.vehicle_id,
        id         : response.invoice_id
      });
    })
    .catch(err => {
      messages.error(err);
    });
  };

  vm.returnToEvent = function () {
    vm.inspection.returnToEvent()
    .then(response => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.INSPECTION_RETURNED'), 'success');

      $state.go('app.event', {
        customer_id: response.customer_id,
        vehicle_id : response.vehicle_id,
        id         : response.event_id
      });
    })
    .catch(err => {
      messages.error(err);
    });
  };

  vm.returnToInvoice = function () {
    vm.inspection.returnToInvoice()
    .then(response => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.INSPECTION_RETURNED'), 'success');

      $state.go('app.invoice', {
        customer_id: response.customer_id,
        vehicle_id : response.vehicle_id,
        id         : response.invoice_id
      });
    })
    .catch(err => {
      messages.error(err);
    });
  };

  vm.email = function () {
    vm.inspection.email(vm.vehicle, vm.companyMessages.inspection_email_message)
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.CUSTOMER_HAS_BEEN_EMAILED'), 'success');
    });
  };

  vm.sms = function () {
    vm.inspection.sms(vm.customer, vm.companyMessages.inspection_sms_message)
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.CUSTOMER_HAS_BEEN_MESSAGED'), 'success');
    });
  };

  vm.print = function () {
    vm.inspection.print()
    .then(() => {
      messages.show($translate.instant('INSPECTIONS_SPACE.INSPECTION_HAS_BEEN_PRINTED'), 'success');
    });
  };

  vm.approveItems = function () {
    vm.inspection.approveItems()
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.ITEMS_APPROVED'), 'success');
      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  vm.viewAttached = function (attached) {
    //attached is either invoice or event
    $state.go('app.' + attached, {
      customer_id: vm.inspection.customer_id,
      vehicle_id : vm.inspection.vehicle_id,
      id         : vm.inspection[attachedId]
    });
  };
};